import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { SkipLinksContext } from './skip-link-context';
export var SkipLinksController = function SkipLinksController(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      links = _useState2[0],
      setLinks = _useState2[1];

  var context = {
    registerSkipLink: function registerSkipLink(skipLinkData) {
      // Don't add duplicate SkipLinks
      if (!links.map(function (link) {
        return link.id;
      }).includes(skipLinkData.id)) {
        setLinks([skipLinkData].concat(_toConsumableArray(links)));
      }
    },
    skipLinksData: links,
    unregisterSkipLink: function unregisterSkipLink(id) {
      setLinks(function (links) {
        return links.filter(function (link) {
          return link.id !== id;
        });
      });
    }
  };
  return /*#__PURE__*/React.createElement(SkipLinksContext.Provider, {
    value: context
  }, children);
};